import MoreDots from '../../src/legacy/MoreDots.tsx';
export default MoreDots;
